function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 116.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10a64a",
      fillRule: "evenodd"
    },
    d: "M61.37 8.24 80.43 0l10.45 17.79 20.27 4.53-2 20.53 13.73 15.58-13.68 15.44 1.95 20.68L91 99l-10.57 17.87-18.92-8.25-19.06 8.25L32 99.08l-20.27-4.53 2-20.54L0 58.43l13.68-15.44-1.95-20.67 20.15-4.45L42.45 0l18.92 8.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.92 65c-6.07-6.53 3.25-16.26 10-10.1 2.38 2.17 5.84 5.34 8.24 7.49l18.5-22.73c6.44-6.66 16.61 3.12 10.25 9.82L61.67 77.2a7.13 7.13 0 0 1-9.9.44C47.83 73.89 42.05 68.5 37.92 65Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.1a52fc05b827ee9fe2987277370e8be8.svg";
export { ForwardRef as ReactComponent };